<template>
    <div class="u-d-inline">
        <header-section
            title="BC Legal - ABC Quantum"
            set-position="relative"
            set-width="100">
        </header-section>
        <div id="app" class="o-content ie">
            <div class="p-homepage__content flex-grid">
                <div class="p-homepage__object flex-grid__g-3">
                    <div class="a-logo-image--homepage">
                        <svg viewBox="0 0 400 53.8">
                            <use xlink:href="#logo"></use>
                        </svg>
                    </div>
                    <span>Welcome to the<br/> 
                    <b>ABC Quantum Tool</b></span><br/>
        
                    The most comprehensive quantum calculator for all types of occupational disease &amp; personal injury claims &mdash; including fatal claims, lost years claims &amp; those of utmost severity.
                </div>
                <div class="p-homepage__object flex-grid__g-7 u-no-margin v-image">
                    <img src="static/video/mockup.png">
                </div>
                <div class="p-homepage__object flex-grid__g-7 u-no-margin v-video">
                    <video id="video" src="static/video/quantum.mp4" type="video/mp4" controls>
                    Sorry, your browser doesn't support embedded videos, 
                    but don't worry, you can <a href="">download it</a>
                    and watch it with your favorite video player!
                    </video>
                </div>
            </div>

            <div class="p-homepage__policies">
                <modal-in-the-wild modal-name="homepage_cookie_policy">
                    <p class="c-modal-in-the-wild">Cookie Policy</p>
                </modal-in-the-wild>

                |

                <modal-in-the-wild modal-name="homepage_disclaimer">
                    <p class="c-modal-in-the-wild">Disclaimer</p>
                </modal-in-the-wild>
    
                |

                <a href="https://quantum.internal.bc-legal.co.uk/api/v1/licenses/security-policy.pdf" target="_blank">
                    <p class="c-modal-in-the-wild">Security Policy</p>
                </a>

                |

                <a href="https://quantum.internal.bc-legal.co.uk/api/v1/licenses/privacy-policy.pdf" target="_blank">
                    <p class="c-modal-in-the-wild">Privacy Policy</p>
                </a>

                |

                <a href="https://quantum.internal.bc-legal.co.uk/api/v1/licenses/license-agreement.pdf" target="_blank">
                    <p class="c-modal-in-the-wild">License Agreement</p>
                </a>
            </div>

            <modal name="homepage_disclaimer" no-default-button="true">
                <disclaimer></disclaimer>
            </modal> 

            <modal name="homepage_cookie_policy" no-default-button="true">
                <cookie-policy></cookie-policy>
            </modal>    

        <!--     <modal name="homepage_security_policy" no-default-button="true">
                <security-policy></security-policy>
            </modal>    

            <modal name="homepage_privacy_policy" no-default-button="true">
                <privacy-policy></privacy-policy>
            </modal>    -->
        </div>
    </div>
</template>

<script>
    import CookiePolicy from 'components/policies/CookiePolicy.vue';
    import Disclaimer from 'components/policies/Disclaimer.vue';
    import dropdown from 'components/dropdown/Dropdown.vue';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';
    import ModalInTheWild from 'components/modal/ModalInTheWild.vue';
    // import PrivacyPolicy from 'components/policies/PrivacyPolicy.vue';
    // import SecurityPolicy from 'components/policies/SecurityPolicy.vue';
    import HeaderSection from 'components/Header.vue';
    import Vue from 'vue';
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: 'homepage',
        components: {
            CookiePolicy,
            Disclaimer, 
            Modal,
            ModalContent, 
            ModalInTheWild, 
            // PrivacyPolicy,
            // SecurityPolicy,
            HeaderSection
        },
        mounted: function () {
            let video = document.querySelector('.v-video');
            video.style.display = 'none';
            document.querySelector('.v-image').addEventListener('click', playVideo);

            function playVideo() {
                this.style.display = 'none';
                video.style.display = 'block';
                document.querySelector('#video').play();
            }
        },
    }
</script>

<style lang="scss">
    .v-image {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// Homepage.vue?178c7e38